import type { EntryPointRouteParams } from '@jira/platform__entry-points-plugin-types/src/types.tsx';
import { JSResourceForInteraction } from '@atlassian/react-async';
import { createEntryPoint } from '@atlassian/react-entrypoint';
import parameters from '@atlassian/jira-relay/src/__generated__/FirstCreateViewQuery$parameters';

export const aiFirstCreateEntryPoint = createEntryPoint({
	root: JSResourceForInteraction(
		() => import(/* webpackChunkName: "async-ai-first-create-entrypoint" */ './src/index.tsx'),
	),
	getPreloadProps: (entryPointRouteParams: EntryPointRouteParams) => {
		const { context, tenantContext } = entryPointRouteParams;
		const { cloudId } = tenantContext;

		const projectIdOrKey = String(context.query?.projectIdOrKey ?? '');

		return {
			queries: {
				firstCreateQueryRef: {
					options: {
						fetchPolicy: 'store-and-network' as const,
					},
					parameters,
					variables: {
						cloudId,
						projectIdOrKey,
					},
				},
			},
			entryPoints: {},
			extraProps: {
				projectIdOrKey,
			},
		};
	},
});
